<template>
  <div class="calendar__modal-content">
    <p id="add-to-calendar-description">
      Add this event to your Google, iCal, or Outlook calendar by clicking one of the links below.
      {{ showRegistrationMessage ? 'Registration is still required.' : '' }}
    </p>
    <CdrList>
      <li>
        <CdrLink
          :href="googleCalendarURL"
          target="_blank"
          @click="handleClick"
        >
          <span class="calendar__sr-only">Add to:</span>
          Google Calendar
          <IconExternalLink
            inherit-color
            class="calendar__external-link"
            size="small"
          />
        </CdrLink>
      </li>
      <li>
        <CdrLink
          :href="calendarURL"
          download
          @click="handleClick"
        >
          <span class="calendar__sr-only">Add to:</span>
          iCal
        </CdrLink>
      </li>
      <li>
        <CdrLink
          :href="calendarURL"
          download
          @click="handleClick"
        >
          <span class="calendar__sr-only">Add to:</span>
          Outlook
        </CdrLink>
      </li>
    </CdrList>
  </div>
</template>

<script>
import { CdrLink, IconExternalLink, CdrList } from '@rei/cedar';
import qs from 'query-string';
import moment from 'moment';
import metrics from '../../../mixins/metrics';

const GOOG_TIME = 'YYYYMMDD[T]HHmmss[Z]';

export default {
  name: 'AddToCalendarModal',
  components: {
    CdrLink,
    IconExternalLink,
    CdrList,
  },
  mixins: [metrics],
  props: {
    sessionId: {
      type: [Number, String],
      required: true,
    },
    eventStart: {
      type: String,
      required: true,
    },
    eventEnd: {
      type: String,
      required: true,
    },
    eventTitle: {
      type: String,
      required: true,
    },
    eventLocationName: {
      type: String,
      required: true,
    },
    eventUri: {
      type: String,
      required: true,
    },
    eventRegistrationStatus: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    baseUri() {
      // TODO: drop the http protocol
      // TODO: handle future/next?
      return 'http://www.rei.com';
    },
    showRegistrationMessage() {
      return this.eventRegistrationStatus === true;
    },
    calendarURL() {
      return `/events/${this.sessionId}/calendar`;
    },
    googleCalendarURL() {
      const eventStart = moment.parseZone(this.eventStart).utc().format(GOOG_TIME);
      const eventEnd = moment.parseZone(this.eventEnd).utc().format(GOOG_TIME);
      const googleQueryString = qs.stringify({
        action: 'TEMPLATE',
        text: this.eventTitle,
        location: this.eventLocationName,
        dates: `${eventStart}/${eventEnd}`,
        details: encodeURI(`${this.baseUri}${this.eventUri}`),
      });
      // TODO: drop the http protocol?
      return `http://www.google.com/calendar/event?${googleQueryString}`;
    },
  },
  methods: {
    handleClick({ target }) {
      const [, type] = target.innerText.split('\n');
      const linkName = `{{ pageName }}_add to calendar modal_${type}`;
      this.metricsClick({ linkName });
    },
  },
};
</script>
